import { render, staticRenderFns } from "./ConfigurationPremappedProductMappings.vue?vue&type=template&id=68f7c065&"
import script from "./ConfigurationPremappedProductMappings.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPremappedProductMappings.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPremappedProductMappings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports